import { render, staticRenderFns } from "./TheoryManageLayout.vue?vue&type=template&id=1bdc4f20&scoped=true"
import script from "./TheoryManageLayout.vue?vue&type=script&lang=js"
export * from "./TheoryManageLayout.vue?vue&type=script&lang=js"
import style0 from "./TheoryManageLayout.vue?vue&type=style&index=0&id=1bdc4f20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc4f20",
  null
  
)

export default component.exports